import * as Actions from './actions'
import initialState from '../store/initialState'

export const SpotifyReducer = (state = initialState.spotify, action: any) => {
    switch (action.type) {
        case Actions.SET_SPOTIFY_VALUE:
            return {
                ...state,
                ...action.payload
            }
        default:
            return state;
    }
}